<section class="pt-3">
  <screen-support></screen-support>  
</section>


<section class="sfe-safe pt-5 sfe-welcome">
  <div class="welcome-text">
    <h1 class="sfe-welcome-head">Business Operating Summary</h1>
    <p>
      This section is a current Operations Health Score, and outputs action items into your Action Item List, intended to improve your business health.
      View your scores out of total possible points, to determine a strategy. Below are action summaries for each category. Action Items have been added to your business 
      Action Plan to begin implementing and improving your business operations where needed.
    </p>
  </div>
  <div class="sfe-welcome-img">

  </div>

 </section>

<nav aria-label="breadcrumb" class="pt-5 ">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active">
      <div *ngIf="authService.isAdmin == false">
            <a routerLink="/entrep-dash">Dashboard</a>
          </div>
          <div *ngIf="authService.isAdmin == true">
            <a routerLink="/admin-dash">Dashboard</a>
        </div>
    </li>
   
    <li class="breadcrumb-item active" aria-current="page">Operating Results</li>
  </ol>
</nav> 

<ng-template #pending>
  <div class="mat-spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<section  class="sfe-safe" *ngIf="show">
  <div id="element-to-export">
    
   <div id="zdex" *ngIf="!pendingData else pending" >
    
    <article class="pt-5 pb-2" >
      <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
          <mat-card class="sfe-card">
            <mat-card-title-group>
                <mat-card-title>
                    Action Items Added
                </mat-card-title>
                <mat-card-subtitle>
                   <!--something-->
                </mat-card-subtitle>
               <mat-icon class="icon-size">track_changes</mat-icon>
            </mat-card-title-group>
            <mat-card-content>
              <br/>
              <div [ngClass]="{'show-less': showTxtDescription}" >
                <p > 
                  The following Action Items have been added to your Action Plan based on your assessment results.  
                  <a type="button"  color="primary" routerLink="/action-plan">View Plan
                </a>    
              </p>
              <br/>
                <ul>
                  <li *ngFor="let action of assessmentPayload?.actionItemsArray">
                     {{action}}
                  </li>
                </ul>
                 
               
                </div>
                <div class="pt-2"></div>
              </mat-card-content>
              <mat-divider inset></mat-divider>
                <mat-card-actions>
                    <button mat-button (click)="showTxt()">{{ showTxtDescription ? 'READ MORE': 'READ LESS' }}</button>
                </mat-card-actions>
          </mat-card>
      </div>
    </article>
    
    <article class="pt-5 white-bg" >
      <div class="container-fluid">
          
          <div class="sfe">
              <h2>Business Details</h2>
              <div class="table-responsive pt-2">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Business Name</th>
                      <th scope="col">Owner Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Telephone</th>
                    </tr>
                  </thead>
                  <tr>
                    <td>{{data?.busiName}}</td>
                    <td>{{data?.busiFirstName}} {{data?.busiLastName}}</td>
                    <td>{{data?.busiEmail}}</td>
                    <td>{{data?.busiTelephone}}</td>
                  </tr>
                  
                </table>
              </div>
            </div>
          </div>
        <div class="pb-5"></div>
      </article>
      <article class="pt-5 sfe"> 
            <div class="row">
            
              <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                <mat-card class="sfe-card">
                
                    <mat-card-title-group>
                          <mat-card-title>
                            <h1 class="teal">
                              {{assessmentPayload?.strategyScore?.strategyUserTotalInput}}/{{assessmentPayload?.strategyScore?.strategyScoreGradePossible}}
                            </h1>
                          </mat-card-title>
                          <mat-card-subtitle>Strategy</mat-card-subtitle>
                          <img class="card-img-top img-fluid"  src="../../../assets/imgs/Strategy.png" alt="Strategy">
                      </mat-card-title-group>
                  <mat-card-content>
                      <h3 class="teal">How is your business strategy?</h3>
                    <div [ngClass]="{'show-less': showShortStratDesciption}">
                        <div *ngIf="data?.busiRegType?.name == 'Not registered'; else busiRegTypeElse">
                          {{data?.busiName}} is not an existing company and is not registered yet.
                        </div>

                        <ng-template #busiRegTypeElse>
                          {{data?.busiName}} is registered as a {{data?.busiRegType?.name}}.
                        </ng-template>

                        <div *ngIf="data?.practicalCompHistoryExistingCompany?.name == 'Yes' && data?.practicalCompHistoryExistingCustomerBase?.name == 'Yes'; else practicalCompHistoryExistingCompanySecond">
                          It's an existing company with an existing customer base and plans to operate in the following ways: {{assessmentPayload?.practicalOperationsArray}}. 
                        </div>
                        <ng-template #practicalCompHistoryExistingCompanySecond>
                          <ng-container *ngIf="data?.practicalCompHistoryExistingCompany?.name == 'Yes' && data?.practicalCompHistoryExistingCustomerBase?.name == 'No'; else practicalCompHistoryExistingCompanyThird">
                            It's an existing company with an existing customer base and plans to operate in the following ways: {{assessmentPayload?.practicalOperationsArray}}. 
                          </ng-container>
                        </ng-template>
                        <ng-template #practicalCompHistoryExistingCompanyThird>
                          <ng-container *ngIf="data?.practicalCompHistoryExistingCompany?.name == 'No'">
                            It's not an existing company but plans to operate in the following ways: {{assessmentPayload.practicalOperationsArray}}. 
                          </ng-container>
                        </ng-template>

                    <!--Business Plan-->
                        <div *ngIf="assessmentPayload?.practicalBusiPlanNeedsWork?.length >=1; else businessPlanElse">
                          {{data?.busiName}} needs to work on the following segments in their business plan:  {{assessmentPayload?.practicalBusiPlanNeedsWork}}.
                        </div>
                        <ng-template #businessPlanElse>
                        {{data?.busiName}}'s business plan is in good shape.
                        </ng-template>

                        <!--Customer Service-->
                  <div *ngIf="1 >= data?.practicalStrategyCustomerService?.value; else customerServiceElse">
                    The business needs assistance in customer service.
                  </div>
                  <ng-template #customerServiceElse>
                    {{data?.busiName}}'s customer service is in good shape.
                    </ng-template>
                          <!--Customer Engagment-->
                  <div *ngIf="1 >= data?.practicalStrategyCustomerEngagement?.value; else customerEngagementElse">
                    The business needs assistance in customer engagement.
                  </div>
                  <ng-template #customerEngagementElse>
                    {{data?.busiName}}'s customer engagement is in good shape.
                    </ng-template>
              </div>
              </mat-card-content>
              <mat-divider inset></mat-divider>
                  <mat-card-actions>
                    <button mat-button (click)="stratText()">{{ showShortStratDesciption ? 'READ MORE': 'READ LESS' }}</button>
                  </mat-card-actions>
                </mat-card>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                <mat-card class="sfe-card">
                    <mat-card-title-group>
                      <mat-card-title>
                        <h1 class="teal">
                          {{assessmentPayload?.financeScore?.financeUserTotalInput}}/{{assessmentPayload?.financeScore?.financeScoreGradePossible}} 
                        </h1>
                      </mat-card-title>
                      <mat-card-subtitle>Finance</mat-card-subtitle>
                      <img class="card-img-top img-fluid"  src="../../../assets/imgs/Finance.png" alt="Finance">
                    </mat-card-title-group>
                    <mat-card-content>
                      <h3 class="teal">How are your finance operations?</h3>
                    <div [ngClass]="{'show-less': showShortFinDesciption}">
                        <!--Revenue Strategy-->
                        {{data?.busiName}}'s revenue model consists of the following: {{assessmentPayload?.practicalFinanceIncomeStrategyArray}}.
                        <!--Capital-->  
                        <ng-container *ngIf="'Nome' == data?.capitalSeeking?.name; else capitalSeekingNotSure">
                          {{data?.busiName}} is not looking for capital.
                          </ng-container>
                          <ng-template #capitalSeekingNotSure>
                            <ng-container *ngIf="'I`m not sure how much' == data?.capitalSeeking?.name; else capitalSeekingAmount">
                            {{data?.busiName}} is looking for capital, but is not sure for how much.
                            </ng-container>
                          </ng-template>
                          <ng-template #capitalSeekingAmount>
                            {{data?.busiName}} is looking for capital: {{data?.capitalSeeking?.name}}.
                          </ng-template>
                        <!--Payment System-->
                        <ng-container *ngIf="'Yes, I know how to use it' == data?.practicalFinancePaymentSystem?.name; else practicalFinancePaymentSystemSecond">
                        {{data?.busiName}} actively uses a payment system and/or has one set up.
                        </ng-container>
                        <ng-template #practicalFinancePaymentSystemSecond>
                          <ng-container *ngIf="'Yes, but I don`t know how to use it' == data?.practicalFinanceAccountingSystem?.name; else practicalFinancePaymentSystemThird">
                          {{data?.busiName}} actively uses a payment system and/or has one set up, but needs help using it efficiently.
                          </ng-container>
                        </ng-template>
                        <ng-template #practicalFinancePaymentSystemThird>
                        {{data?.busiName}} needs a payment system.
                        </ng-template>
                        <!--Accounting System-->
                        <ng-container *ngIf="'Yes, I know how to use it' == data?.practicalFinanceAccountingSystem?.name; else practicalFinanceAccountingSystemsecond">
                        {{data?.busiName}} actively uses an accounting system and/or has one set up.
                        </ng-container>
                        <ng-template #practicalFinanceAccountingSystemsecond>
                          <ng-container *ngIf="'Yes, but I don`t know how to use it' == data?.practicalFinanceAccountingSystem?.name; else practicalFinanceAccountingSystemthird">
                            {{data?.busiName}} actively uses an accounting system and/or has one set up, but needs help using it efficiently.
                          </ng-container>
                        </ng-template>
                        <ng-template #practicalFinanceAccountingSystemthird>
                        {{data?.busiName}} needs an accounting system.
                        </ng-template>
                        <!--Finance Knowledge-->
                        <div *ngIf="1 >= assessmentPayload?.practicalFinanceNeedsWork?.length; else financeElse">
                        {{data?.busiName}} needs to learn more in the following areas of fiance:  {{assessmentPayload?.practicalFinanceNeedsWork}}.
                          </div>
                        <ng-template #financeElse>
                          {{data?.busiName}} has a good understanding of finance.
                        </ng-template>
                    </div>
              </mat-card-content>
              <mat-divider inset></mat-divider>
                  <mat-card-actions>
                    <button mat-button (click)="finText()">{{ showShortFinDesciption ? 'READ MORE': 'READ LESS' }}</button>
                  </mat-card-actions>
                </mat-card>
              </div>
          
              <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                <mat-card class="sfe-card">
                    <mat-card-title-group>
                      <mat-card-title>
                        <h1 class="teal">
                          {{assessmentPayload?.legalScore?.legalUserTotalInput}}/{{assessmentPayload?.legalScore?.legalScoreGradePossible}}  
                        </h1>
                      </mat-card-title>
                      <mat-card-subtitle>Legal</mat-card-subtitle>
                      <img class="card-img-top img-fluid"  src="../../../assets/imgs/Legal.png" alt="Legal">
                    </mat-card-title-group>
                    <mat-card-content>
                      <h3 class="teal">How are your legal operations?</h3>
                    <div [ngClass]="{'show-less': showShortLegalDesciption}">
                      <!--Legal Operating Agreement-->
                      <div *ngIf="'Yes' == data?.practicalLegalOpAgreement?.name; else practicalLegalOpAgreementelse"> 
                        {{data?.busiName}} has a solid operating agreement.
                      </div>
                        <ng-template #practicalLegalOpAgreementelse>
                          <ng-container *ngIf="'No' == data?.practicalLegalOpAgreement?.name">
                            {{data?.busiName}} needs a solid operating agreement.
                          </ng-container>
                        </ng-template>
                            <!--Legal Disclaimers-->
                        <ng-container *ngIf="'Yes' == data?.practicalLegalDisclaimers?.name; else practicalLegalDisclaimerssecond">
                          {{data?.busiName}} has solid disclaimers.
                          </ng-container>
                          <ng-template #practicalLegalDisclaimerssecond>
                            <ng-container *ngIf="'I don`t need them' == data?.practicalLegalDisclaimers?.name; else practicalLegalDisclaimersthird">
                              {{data?.busiName}} doesn't need dislcaimers. 
                            </ng-container>
                          </ng-template>
                          <ng-template #practicalLegalDisclaimersthird>
                            {{data?.busiName}} needs solid disclaimers. 
                          </ng-template>
                        <!--Legal IP-->
                        {{data?.busiName}} {{data?.practicalLegalIP?.name}}     
                    </div>
              </mat-card-content>
            
                  <mat-divider inset></mat-divider>
                  <mat-card-actions>
                      <button mat-button (click)="legalText()">{{ showShortLegalDesciption ? 'READ MORE': 'READ LESS' }}</button>
                  </mat-card-actions> 
                  
                </mat-card>
              </div>
            </div>
            <div #operating>
              <div class="row">    
                <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                  <mat-card class="sfe-card">
                      <mat-card-title-group>
                        <mat-card-title>
                          <h1 class="purple-txt">
                            {{assessmentPayload?.marketingScore?.marketingUserTotalInput}}/{{assessmentPayload?.marketingScore?.marketingScoreGradePossible}} 
                          </h1>
                        </mat-card-title>
                        <mat-card-subtitle>Marketing</mat-card-subtitle>
                        <img class="card-img-top img-fluid"  src="../../../assets/imgs/Marketing.png" alt="Marketing">
                      </mat-card-title-group>
                      <mat-card-content>
                        <h3 class="purple-txt">How is marketing going?</h3>
                      <div [ngClass]="{'show-less': showShortMarketingDesciption}">
                        <!--Marketing Website-->
                      <ng-container *ngIf="2 == data?.practicalMarketingWebsite?.value; else practicalMarketingWebsitesecond">
                        {{data?.busiName}} has a website.
                      </ng-container>
                      <ng-template #practicalMarketingWebsitesecond>
                        <ng-container *ngIf="1 == data?.practicalMarketingWebsite?.value; else practicalMarketingWebsitethird">
                          {{data?.busiName}} has a website, but it needs work.
                        </ng-container>
                      </ng-template>
                      <ng-template #practicalMarketingWebsitethird>
                        {{data?.busiName}} has a website.
                      </ng-template>
                      <!--Marketing Brand-->
                      <div *ngIf="2 == data?.practicalMarketingBrand?.value; else practicalMarketingBrandElse"> 
                        {{data?.busiName}} has a consistent and professional brand.
                      </div>
                      <ng-template #practicalMarketingBrandElse>
                        {{data?.busiName}} needs a consistent and professional brand.
                        </ng-template>
                          <!--Marketing Effectiveness-->
                        <div *ngIf="2 == data?.practicalMarketingBrand?.value; else practicalMarketingEffectElse "> 
                          {{data?.busiName}} understands marketing strategies.
                        </div> 
                          <ng-template #practicalMarketingEffectElse>
                          {{data?.busiName}} needs marketing assistance and training.
                          </ng-template>
                          <!--Marketing Network-->
                          <div *ngIf="2 == data?.practicalMarketingNetworkMaterial?.value; else practicalMarketingNetworkMaterialElse "> 
                            {{data?.busiName}} has effective marketing material for networking.
                          </div>
                          <ng-template #practicalMarketingNetworkMaterialElse>
                            {{data?.busiName}} needs marketing material for networking. 
                            </ng-template> 
                      </div>
                </mat-card-content>
                <mat-divider inset></mat-divider>
                    <mat-card-actions>
                      <button mat-button (click)="marketingText()">{{ showShortMarketingDesciption ? 'READ MORE': 'READ LESS' }}</button>
                    </mat-card-actions>
                  </mat-card>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                  <mat-card class="sfe-card">
                      <mat-card-title-group>
                        <mat-card-title>
                          <h1 class="purple-txt">
                            {{assessmentPayload?.hiringScore?.hiringUserTotalInput}}/{{assessmentPayload?.hiringScore?.hiringScoreGradePossible}}  
                          </h1>
                        </mat-card-title>
                        <mat-card-subtitle>Hiring & HR</mat-card-subtitle>
                        <img class="card-img-top img-fluid"  src="../../../assets/imgs/HR.png" alt="HR">
                      </mat-card-title-group>
                      <mat-card-content>
                        <h3 class="purple-txt">How is your HR health?</h3>
                      <div [ngClass]="{'show-less': showShortHiringDesciption}">
                        <!--Company Culture Strategies-->
                      {{data?.busiName}} currently fosters company culture and employee retention through the following activities: {{assessmentPayload?.practicalHREmployeeRetentionArray}}. 
                      <!--Hiring Retention-->
                <div *ngIf="3 >= assessmentPayload?.practicalHREmployeeRetentionArray?.length">
                  The business should identify more ways to increase employee retention.
                </div>
                        <!--Hiring Needs Work-->
                <div *ngIf="assessmentPayload?.practicalHRHiringNeedsWork?.length >= 1; elsehiringElse">
                    {{data?.busiName}} needs assistance in the following hiring practices: {{assessmentPayload?.practicalHRHiringNeedsWork}}. 
                    </div>
                <ng-template #elsehiringElse>
                  {{data?.busiName}} is comfortable with their hiring process.
                    </ng-template>
      
                      </div>
                </mat-card-content>
                
                    <mat-divider inset></mat-divider>
                    <mat-card-actions>
                      <button mat-button (click)="hiringText()">{{ showShortHiringDesciption ? 'READ MORE': 'READ LESS' }}</button>
                    </mat-card-actions>
                
                  </mat-card>
                </div>
            
                <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                  <mat-card class="sfe-card">
                      <mat-card-title-group>
                        <mat-card-title>
                          <h1 class="purple-txt">
                            {{assessmentPayload?.operationsScore?.operationsUserTotalInput}}/{{assessmentPayload?.operationsScore?.operationsScoreGradePossible}}  
                          </h1>
                        </mat-card-title>
                        <mat-card-subtitle>Business Operations</mat-card-subtitle>
                        <img class="card-img-top img-fluid"  src="../../../assets/imgs/Operations.png" alt="Operations">
                      </mat-card-title-group>
                      <mat-card-content>
                        <h3 class="purple-txt">How are the business operations?</h3>
                      <div [ngClass]="{'show-less': showShortOperationDesciption}">
                        <div *ngIf="1 == data?.practicalOpCRM?.value; else practicalOpCRMelse"> 
                          {{data?.busiName}} has identified a client management system.
                        </div>
                        <ng-template #practicalOpCRMelse>
                        {{data?.busiName}} has not identified a client management system.
                        </ng-template>
                              <!--Operating Procedures-->
                          <div *ngIf=" 1 == data?.practicalOpSOP?.value; else practicalOpSOPelse"> 
                          {{data?.busiName}} has created thorough operating procedures for business continuity.
                          </div>
                          <ng-template #practicalOpSOPelse>
                          {{data?.busiName}} needs standard operating prodcedures to assist business growth and continuity.
                            </ng-template>
                                <!--Production Process-->
                            <div *ngIf="'Yes' == data?.practicalOpProductionProcess?.name; else practicalOpProductionProcesselse"> 
                            {{data?.busiName}} has a consistent and stable production process.
                            </div>
                            <ng-template #practicalOpProductionProcesselse>
                              <ng-container *ngIf="'No or not sure' == data?.practicalOpProductionProcess?.name">
                            {{data?.busiName}} may want to create a consistent and/or stable production process.
                              </ng-container>
                            </ng-template>      
                      </div>
                </mat-card-content>
                
                    <mat-divider inset></mat-divider>
                    <mat-card-actions>
                        <button mat-button (click)="operationsText()">{{ showShortOperationDesciption ? 'READ MORE': 'READ LESS' }}</button>
                    </mat-card-actions> 
                    
                  </mat-card>
                </div>
              </div>
            </div>
      </article>
   </div>  
  </div>
</section>
